import React from "react";
import imgReport from "../../../assets/images/reportWelcome.svg";

const HomeReports = () => {
  return (
    <div className="shadow-md bg-gray-100 min-h-fit">
      <div className="flex flex-col-reverse lg:flex-row xl:justify-between">
        <div>
          <img
            src={imgReport}
            className="p-4 lg:pb-4 lg:pl-8 object-cover md:object-left mx-auto"
          />
        </div>
        <div className="m-4 pr-2 text-center lg:text-right xl:text-right 2xl:text-right">
          <h3 className="text-gray-500 text-md lg:text-xl sm:text-sm font-normal leading-normal">
            Welcome to
          </h3>
          <h1 className="text-repModuleColor text-4xl md:text-4xl lg:text-3xl xl:text-4xl font-black leading-normal">
            Reports Module
          </h1>
          <hr className="borderReport mx-20 lg:ml-52 lg:mr-0" />
          <h1 className="text-pleaseColor font-normal text-base leading-relaxed mt-6">
            Please choose from the Side Navigation to start viewing the reports
          </h1>
        </div>
      </div>
    </div>
  );
};
export default HomeReports;
